export default __webpack_public_path__ + "static/media/ai.74e36ea5.png";